// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2dnly","upload":"Small_upload__Uen4d","imageWrap":"Small_imageWrap__2dnw4","removeBtn":"Small_removeBtn__3r_Ow"};